import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { auditor } from 'App';
import { NeedsReviewUI } from './NeedsReview.types';

export function useNeedsReview(page: number): UseQueryResult<NeedsReviewUI> {
  return useQuery(['needs review', page], () => auditor.getNeedsReview(page), {
    select: ({ totalResults, compositeAudits }) => ({
      totalResults,
      compositeAudits: compositeAudits.map(
        ({ examSession, audit, anomalyCount, user, partner }) => ({
          examStartTime: examSession.startTime,
          examEndTime: examSession.endTime,
          auditor: `${user.firstName} ${user.lastName}`,
          auditOfInterest: audit.auditOfInterest,
          auditStart: audit.startTime,
          auditEnd: audit.endTime,
          auditUuid: audit.uuid,
          anomalyCount,
          uuid: examSession.uuid,
          partnerName: partner.name,
          specialPartner: partner.special,
        })
      ),
    }),
    staleTime: undefined,
  });
}
